import React, { Fragment, useState, useEffect } from "react";
import { Button, Form, FormGroup, Label, Input,Row, Col,Container } from "reactstrap";
import { TimePicker } from "react-time-picker";
import Select from "react-select";
import MenuItem from "react-select";
import { render } from "@testing-library/react";
import "../../../style/calendarclass.css";
import moment from "moment";
import { Table, Checkbox } from "semantic-ui-react";
import api from "../../../apis/api";
import {
  useEmpListAssignConfigMail,
  SelectedEmpConfigMail,
  useEmpListAssignEmpConfigMail,
} from "../../../components/employee/index";
import TableWithSortPagtn from "../../../components/common/TableWithSortPagtn";
import Notifications from "../../../components/common/Notifications";
const FormFieldEmployeeWise = React.memo((props) => {
  const { inputFields, formValidation ,intimeval,outtimeval,halfdayworkval,fulldayworkval,departmentList,emplist} = props;
  const [inputFieldsArr, setInputFieldsArr] = useState(null);
const[desoptions , setOptions] =useState([{}]);
const [departmentId,setdepartmentId] =useState("");
const [isTo,setisTo] =useState(false);
const [isBcc,setisBcc] =useState(false);
const [isCc,setisCc] =useState(false);
const [isdirect,setisdirect]=useState(false);
const [istypemail,setistypemail]=useState(false);
const [empData, setEmpData] = useState([]);
const [selectedEmp, setSelectedEmp] = useState([]);
const [selectedEmpWise, setSelectedEmpWise] = useState([]);
const [selectedBccEmp, setSelectedBccEmp] = useState([]);
const [selectedCcEmp, setSelectedCcEmp] = useState([]);
const [selectedFromEmp, setSelectedFromEmp] = useState([]);
const [empArr, setempArr] = useState([]);
const [type,settype] =useState("");
const [selectedToEmp, setSelectedToEMp] = useState([]);
const [selectedBccEmpComma, setSelectedBccEMpComma] = useState([]);
const [selectedCcEmpComma, setSelectedCcEMpComma] = useState([]);
const [selectedFromEmpComma, setSelectedFromEmpComma] = useState([]);
const [error, setError] = useState(null);
let options=[];

useEffect(()=>{   
  setempArr(emplist);
  setEmpData(emplist);
},[emplist]);
   inputFields.map(function (desig) {
    if(desig.type=="multipleselect" && desig.option.length >0)
    {
      desig.option.map((el,i) =>{
       options.push({value: el.designationId, label: el.designationName }); 
      })
     
    }

  })
 
  let intim=moment(intimeval, "hhmma").format("HH:mm");
  let outtim=moment(outtimeval, "hhmma").format("HH:mm");
  const handleOnchangeConfigMail =React.useCallback((depId) =>{
    setdepartmentId(depId);
  })
  const setAllEmployee =React.useCallback(() =>{
    const fetchApi = async () => {
      let array=[];
      await api.employee().getAll().then((res) => array.push(res.data));
      setEmpData(array[0]);
      setempArr(array[0]);
    }
    
    fetchApi();
  })
  const handleTo =React.useCallback((depId) =>{
   setisTo(true);
   setisBcc(false);
   setisCc(false);
   settype(1);
  })
  const handleBcc =React.useCallback((depId) =>{
    setisTo(false);
   setisBcc(true);
   setisCc(false);
   setistypemail(false);
   settype(2);
   setAllEmployee();
  })
  const handleCC =React.useCallback((depId) =>{
    setisTo(false);
   setisBcc(false);
   setisCc(true);
   setistypemail(false);
   settype(3);
   setAllEmployee();
  })
  const handleOnchangeType =React.useCallback((depId) =>{
    if(depId==1)
    {
      setisdirect(true);
      setistypemail(false);
    }
    else
    {
      setisdirect(false);
      setistypemail(true);
      const fetchApi = async () => {
        let array=[];
        await api.employee().getAll().then((res) => array.push(res.data));
        setEmpData(array[0]);
        setempArr(array[0]);
      }
      
      fetchApi();
    }

 
  },[departmentId]);
  const handleSelectedFromEmp = React.useCallback((emp) => {
    let filterEmp = selectedFromEmp.filter((el)=>el.employeeId == emp.employeeId);
    if(filterEmp.length == 0){
      setSelectedFromEmp((precState) => [...precState, emp]);
      setSelectedFromEmpComma((precState) => [...precState, emp.employeeId]);
    }
  },[selectedFromEmp]);
  const handleSelectedEmp = React.useCallback((emp,ty) => {
    if(ty==1)
    {
      let filterEmp = selectedEmp.filter((el)=>el.employeeId == emp.employeeId);
      if(filterEmp.length == 0){
        setSelectedEmp((precState) => [...precState, emp]);
        setSelectedToEMp((precState) => [...precState, emp.employeeId]);
      }
    }
    else if(ty==2)
    {
      let filterEmp = selectedBccEmp.filter((el)=>el.employeeId == emp.employeeId);
      if(filterEmp.length == 0){
        setSelectedBccEmp((precState) => [...precState, emp]);
        setSelectedBccEMpComma((precState) => [...precState, emp.employeeId]);
      }
    }
    else if(ty==3)
    {
      let filterEmp = selectedCcEmp.filter((el)=>el.employeeId == emp.employeeId);
      if(filterEmp.length == 0){
        setSelectedCcEmp((precState) => [...precState, emp]);
        setSelectedCcEMpComma((precState) => [...precState, emp.employeeId]);
      }
    }
    else if(ty == 0)
    {
      let filterEmp = selectedFromEmp.filter((el)=>el.employeeId == emp.employeeId);
      if(filterEmp.length == 0){
        setSelectedFromEmp((precState) => [...precState, emp]);
      }
    }
   
    
  }, [selectedEmp,selectedBccEmp,selectedCcEmp,selectedFromEmp]);
  const handleSelectAllEmp = React.useCallback(
    (e) => {
      //console.log(e.target.checked);
      let checkBox = e.target.checked;
      let tempArr = [];
      if (checkBox) {
        empData.map((employee) => tempArr.push(employee));
        setSelectedEmpWise(tempArr);
      } else {
        setSelectedEmpWise([]);
      }
    },
    [empData]
  );
  const handleSelectAllBccEmp = React.useCallback(
    (e) => {
      //console.log(e.target.checked);
      let checkBox = e.target.checked;
      let tempArr = [];
      if (checkBox) {
        empData.map((employee) => tempArr.push(employee));
        setSelectedBccEmp(tempArr);
      } else {
        setSelectedBccEmp([]);
      }
    },
    [empData]
  );
  const handleSelectAllCcEmp = React.useCallback(
    (e) => {
      //console.log(e.target.checked);
      let checkBox = e.target.checked;
      let tempArr = [];
      if (checkBox) {
        empData.map((employee) => tempArr.push(employee));
        setSelectedCcEmp(tempArr);
      } else {
        setSelectedCcEmp([]);
      }
    },
    [empData]
  );
  const searchEmployee = React.useCallback(
    (searchVal,pvalue) => {
      let tempArr = [];
      if (searchVal !== "") {
        // employee name search..
        empArr.filter((el) =>
        el.employeeName !==null ?  (el.employeeName.toLowerCase().indexOf(searchVal.toLowerCase()) !==
          -1
            ? tempArr.includes(el)
              ? null
              : tempArr.push(el)
            : null) : null
        );
       if(pvalue ==1)
       {
        setSelectedEmpWise(tempArr);
       }
       else{
setEmpData(tempArr);
       }
        
      } else {
        setEmpData(empArr);
      }
    },
    [empArr,setEmpData]
  );
  const delSelectedEmp = React.useCallback(
    (empId) => {
      let filterArr = selectedEmp.filter((el) => el.employeeId !== empId);
      setSelectedEmp(filterArr);

    },
    [selectedEmp,setSelectedEmp]
  );
  const delSelectedFromEmp = React.useCallback(
    (empId) => {
      let filterArr = selectedEmpWise.filter((el) => el.employeeId !== empId);
      setSelectedEmpWise(filterArr);

    },
    [selectedEmpWise,setSelectedEmpWise]
  );
  const delSelectedBccEmp = React.useCallback(
    (empId) => {
      let filterArr = selectedBccEmp.filter((el) => el.employeeId !== empId);
      setSelectedBccEmp(filterArr);

    },
    [selectedBccEmp,setSelectedBccEmp]
  );
  const delSelectedCcEmp = React.useCallback(
    (empId) => {
      let filterArr = selectedCcEmp.filter((el) => el.employeeId !== empId);
      setSelectedCcEmp(filterArr);

    },
    [selectedCcEmp,setSelectedCcEmp]
  );
  const handleAddMailSettings = async () =>{
    let formData = {
      departmentId: 0,
      employeeId:String(selectedFromEmpComma),
      toEmpId: String(selectedToEmp),
      bccEmpId:  String(selectedBccEmpComma),
      ccEmpId:  String(selectedCcEmpComma),
    };
    if(departmentId === '' && selectedToEmp.length === 0 && selectedBccEmpComma.length === 0 && selectedCcEmpComma.length === 0)
    {
      setError({ ...error, message: "Enter Details...", status: 500 });
    }
    else
    {
    // console.log("designationId",designationId.toString());
    await api.dbLeaveTypes().AddEditMailSendingSettings(formData);
    }
  //  addBehavioralAttribute(formData);
  }
// const options = [
//   { value: "Spring", label: "Spring" },
//   { value: "Summer", label: "Summer" },
//   { value: "Autumn", label: "Autumn" },
//   { value: "Winter", label: "Winter" }
// ];
const { thead, trow } = useEmpListAssignConfigMail(empData, handleSelectedEmp,type);
const { thead1, trow1 } = useEmpListAssignEmpConfigMail(empData, handleSelectedFromEmp);
  return (
    <div>
    

    <Fragment>
      <Container className="assign-rewards">
     
              <div className="newdiv">
               <Row className="top-row">
      
              <Col xs={12} sm={5} md={5} lg={5} className=" profile-info-left">
            <Row>
              <Col>
                {" "}
 <div >
  <h5>Employee List</h5>
                {/* <Col>
                <Input
                  type="text"
                  className="d-inline"
                  placeholder="Search Employee...."
                  onChange={(e) => searchEmployee(e.target.value,1)}
                />
              </Col> */}
              <br/>
              
              <TableWithSortPagtn
                thead={thead1}
                trow={trow1}
                pageSize={5}
              ></TableWithSortPagtn>
              <Label check className="check-select-all">
                <Input type="checkbox" onChange={handleSelectAllEmp} />
                Select All
              </Label>
            </div>
           
              </Col>
              
              </Row>
              </Col>
              <Col xs={12} sm={5} md={5} lg={5} className=" profile-info-left">
            <Row>
            <SelectedEmpConfigMail
              selectedEmp={selectedEmpWise}
              delSelectedEmp={delSelectedFromEmp}
              type={0}
            ></SelectedEmpConfigMail> 
              </Row>
              </Col>
              </Row>
              </div>
        <Row className="top-row">
          <Col xs={12} sm={2} md={2} lg={2}>
            <Row>
              <Col>
                {" "}
                <Label check >
                  <Input type="radio"  name="radio2" onClick={handleTo}/> To
                </Label><br/>
                <Label check >
                  <Input type="radio"  name="radio2" onClick={handleBcc}/> Bcc
                </Label><br/>
                <Label check >
                  <Input type="radio"  name="radio2" onClick={handleCC}/> Cc
                </Label>
    {/* <input type="checkBox" onChange={handleTo} checked={isTo}
    /> <Label>To</Label>
  <br/>
    <input type="checkBox" onChange={handleBcc} checked={isBcc}
    /> <Label>BCC</Label>
<br/>
    <input type="checkBox" onChange={handleCC} checked={isCc}
    /> <Label>CC</Label>
<br/> */}
              </Col>
              </Row>
              </Col>
              <Col xs={12} sm={5} md={5} lg={5} className=" profile-info-left">
            <Row>
              <Col>
                {" "}
                {isTo == true ? (<div> <Input
                type="select"
                name="select"
                onChange={(e) => handleOnchangeType(e.target.value)} 
                // filter(n=>n.departmentId == selectedCategoryId)
              >
                <option value="">select Type</option>
               <option value={1}>Direct Report</option>
               <option value={2}>Type MailId</option>
              </Input><br/></div> ) : null } {istypemail ==true ? (     <div >
                <h5>Employee List</h5>
                <Col>
                <Input
                  type="text"
                  className="d-inline"
                  placeholder="Search Employee...."
                  onChange={(e) => searchEmployee(e.target.value)}
                />
              </Col><br/>
              
              <TableWithSortPagtn
                thead={thead}
                trow={trow}
                pageSize={5}
              ></TableWithSortPagtn>
              <Label check className="check-select-all">
                <Input type="checkbox" onChange={handleSelectAllEmp} />
                Select All
              </Label>
            </div>) : null}
                {isBcc == true ? ((     <div >
                  <h5>Employee List</h5>
                <Col>
                <Input
                  type="text"
                  className="d-inline"
                  placeholder="Search Employee...."
                  onChange={(e) => searchEmployee(e.target.value)}
                />
              </Col><br/>
              
              <TableWithSortPagtn
                thead={thead}
                trow={trow}
                pageSize={5}
              ></TableWithSortPagtn>
              <Label check className="check-select-all">
                <Input type="checkbox" onChange={handleSelectAllBccEmp} />
                Select All
              </Label>
            </div>)) : null}
                {isCc == true ? ((     <div >
                  <h5>Employee List</h5>
                <Col>
                <Input
                  type="text"
                  className="d-inline"
                  placeholder="Search Employee...."
                  onChange={(e) => searchEmployee(e.target.value)}
                />
              </Col> <br/>
             
              <TableWithSortPagtn
                thead={thead}
                trow={trow}
                pageSize={5}
              ></TableWithSortPagtn>
              <Label check className="check-select-all">
                <Input type="checkbox" onChange={handleSelectAllCcEmp} />
                Select All
              </Label>
            </div>)) : null}
              </Col>
              
              </Row>
              </Col>
              <Col xs={12} sm={5} md={5} lg={5} className=" profile-info-left">
            <Row>
            {istypemail ==true ? ( <SelectedEmpConfigMail
              selectedEmp={selectedEmp}
              delSelectedEmp={delSelectedEmp}
              type={1}
            ></SelectedEmpConfigMail> ) : null }
            {isBcc == true ? (<SelectedEmpConfigMail
              selectedEmp={selectedBccEmp}
              delSelectedEmp={delSelectedBccEmp}
              type={2}
            ></SelectedEmpConfigMail>) : null }
            {isCc == true ? (<SelectedEmpConfigMail
              selectedEmp={selectedCcEmp}
              delSelectedEmp={delSelectedCcEmp}
              type={3}
            ></SelectedEmpConfigMail>) : null }
              </Row>
              </Col>
              </Row>
            
              </Container>
              <Button
        // color="danger"
        className="assign-reward-btn-submit float-right"
        // outline
        onClick={handleAddMailSettings}
      >
        <i className="far fa-hand-point-up"></i> Assign
      </Button>
      <Notifications notifications={error}></Notifications>
              </Fragment>
    </div>
  );
});

export default FormFieldEmployeeWise;
